export { default } from '@ember-data/serializer/rest';
